import qrImage from "/src/assets/images/modal/tokeQR.svg"

export const modalData = {
    title: "Descarga la App Toke",
    subtitle: "<p>Escanea el código QR para descargar desde </br> la tienda de aplicaciones</p>",
    qrImage: qrImage

}